<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="DHL" name="first">DHL</el-tab-pane>
      <el-tab-pane label="联邦快递" name="second">联邦快递</el-tab-pane>
      <el-tab-pane label="HFM" name="third">HFM</el-tab-pane>
    </el-tabs>
    <el-form
      :inline="true"
      :model="query"
      class="query-form"
      size="small"
      style="margin-top: -20px;"
    >
      <el-form-item>
        <el-button type="primary" icon="el-icon-edit" @click.native="handleInput(null,null)">添加</el-button>
        <el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel()">导出</el-button>
        <el-button type="primary" icon="el-icon-download" @click.native="modelDownLoad">下载模板</el-button>
        <el-upload
          class="upload-btn"
          :action="getUrl()"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :before-upload="uploadLoadings"
          accept=".xls, .xlsx"
          multiple
        >
          <el-button size="small" type="primary" icon="el-icon-upload2">导入</el-button>
        </el-upload>
        <!-- <el-button type="primary" icon="el-icon-upload" size="small" @click="importExcel()">导入</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{background:'#F4F4F5',color:'#606266'}"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column
        label="选择"
        prop="orderid"
        type="selection"
        :show-overflow-tooltip="true"
        width="50"
        align="center"
      />
      <el-table-column label="kg" align="center" prop="weight"/>
      <ol v-for="(item,index) in subAreaList" :key="index">
        <el-table-column v-bind:label="item.subareaname" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.expprices[index] | price(scope.row.expprices[index])}}</span>
          </template>
        </el-table-column>
      </ol>
      <el-table-column width="200" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleForm(scope.$index,scope.row)"
          >修改</el-button>
          <el-button type="danger" size="mini" @click.native="handleDel(scope.row.exppriceid)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
      </transition>
    </div>

    <!-- 增加 -->
    <el-dialog
      :visible.sync="formInput"
      :before-close="hideFormAdd"
      width="800px"
      top="5vh"
      v-dialogDrag
      :title="this.title"
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm1">
        <el-form-item label="最小重量" prop="exppricemin">
          <el-input style="width: 240px" v-model="formData.exppricemin" clearable>
            <template slot="append">kg</template>
          </el-input>
        </el-form-item>
        <el-form-item label="最大重量" prop="exppricemax">
          <el-input style="width: 240px" v-model="formData.exppricemax" clearable>
            <template slot="append">kg</template>
          </el-input>
        </el-form-item>
        <ol v-for="(item,index) in this.formData.subprices" :key="index">
          <el-form-item
            v-bind:label="item.subareaname+'价格'"
            :prop="'subprices[' + index + '].price'"
            :rules="{required: true, message: '请输入价格', trigger: 'blur'}"
          >
            <el-input style="width: 240px" v-model="item.price" clearable>
              <template slot="append">CNY</template>
            </el-input>
          </el-form-item>
        </ol>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideFormInput">取消</el-button>
        <el-button type="primary" @click.native="formSub" :loading="formLoading">保存</el-button>
      </div>
    </el-dialog>
    <!--修改-->
    <el-dialog
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="800px"
      top="5vh"
      v-dialogDrag
      :title="this.title"
    >
      <el-form :model="priceInfo" :rules="formRules" ref="dataForm">
        <el-form-item label="最小重量" prop="exppricemin">
          <el-input style="width: 240px" v-model="priceInfo.exppricemin" clearable>
            <template slot="append">kg</template>
          </el-input>
        </el-form-item>
        <el-form-item label="最大重量" prop="exppricemax">
          <el-input style="width: 240px" v-model="priceInfo.exppricemax" clearable>
            <template slot="append">kg</template>
          </el-input>
        </el-form-item>
        <ol v-for="(item,index) in priceInfo.subprices" :key="index">
          <el-form-item
            v-bind:label="item.subareaname+'价格'"
            :prop="'subprices[' + index + '].price'"
            :rules="{required: true, message: '请输入价格', trigger: 'blur'}"
          >
            <el-input style="width: 240px" v-model="item.price" clearable>
              <template slot="append">CNY</template>
            </el-input>
          </el-form-item>
        </ol>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
    getList,
    getSubArea,
    deleteExpPrice,
    updateExpPrice,
    addExpPrice,
    getPriceInfo
} from "../../api/freight/freight.js";
import { BASE_URL } from "../../config/app";
const formJson = {
    exppricemin: "",
    exppricemax: "",
    subprices: []
};
export default {
    data() {
        return {
            title: "DHL运费设置",
            expprices: [],
            price: "",
            cancelToggle: false,
            query: {
                expressid: 1,
                exppriceid: "",
                currentPage: 1,
                pageSize: 10,
                expressids: []
            },
            list: [],
            subAreaList: [],
            data: formJson,
            priceInfo: {
                exppricemin: "",
                exppricemax: "",
                subprices: []
            },
            loading: true,
            formInput: false,
            formVisible: false,
            formLoading: false,
            formMap: {
                add: "添加",
                edit: "编辑",
                detail: "详情"
            },
            formRules: {
                exppricemin: {
                    required: true,
                    message: "请输入",
                    trigger: "blur"
                },
                exppricemax: {
                    required: true,
                    message: "请输入",
                    trigger: "blur"
                }
            },
            // uploadAction :BASE_URL +"/expPriceManage/importEx?expressid="+this.id,
            formData: formJson,
            multipleSelection: [], //多选集合
            activeName: "first"
        };
    },
    methods: {
        handleClick(tab, event) {
            this.loading = true;
            setTimeout(() => {
                this.list = [];
                this.subAreaList = [];
                if (tab.label == "HFM") {
                    this.query.expressid = 3;
                    this.title = "HFM运费设置";
                } else if (tab.label == "联邦快递") {
                    this.query.expressid = 2;
                    this.title = "联邦快递运费设置";
                } else if (tab.label == "DHL") {
                    this.query.expressid = 1;
                    this.title = "DHL运费设置";
                }
                this.getSubArea();
            }, 0.3 * 1000);
        },
        getUrl() {
            return (
                BASE_URL +
                "/expPriceManage/importEx?expressid=" +
                this.query.expressid
            );
        },
        getSubArea() {
            this.loading = true;
            getSubArea(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.subAreaList = response.data || [];
                    this.formData.subprices = this.subAreaList;
                    console.log(this.formData.subprices);
                    this.getList();
                })
                .catch(() => {
                    this.subAreaList = [];
                    this.loading = false;
                    this.totalNumber = 0;
                });
        },
        getList() {
            this.loading = true;
            getList(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data || [];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.totalNumber = 0;
                });
        },
        //导出
        exportExcel() {
            window.location.href =
                BASE_URL +
                "/expPriceManage/export?expressid=" +
                this.query.expressid;
        },
        //模版下载
        modelDownLoad() {
            window.location.href =
                BASE_URL +
                "/expPriceManage/modelDownLoad?expressid=" +
                this.query.expressid;
        },
        uploadLoadings() {
            this.loading = true;
        },
        handleAvatarSuccess(response) {
            if (response.code) {
                this.$message.error(response.message);
                this.loading = false;
                return false;
            }
            var t;
            clearTimeout(t);
            t = setTimeout(() => {
                console.log("执行了");
                this.$message.success("导入成功");
                this.getList();
            }, 5000);
        },
        handleAvatarError() {
            this.$message.error("上传文件出错");
            this.loading = false;
        },
        //添加
        handleInput() {
            if (this.$refs["dataForm1"]) {
                this.$refs["dataForm1"].resetFields();
            }
            this.formInput = true;
            // 清空验证信息表单
        },
        hideFormAdd() {
            // 更改值
            this.formInput = false;
            this.$refs["dataForm1"].resetFields();

            return true;
        },
        hideFormInput() {
            // 更改值
            this.formInput = !this.formInput;
            this.$refs["dataForm1"].resetFields();
            return true;
        },
        formSub() {
            this.$refs["dataForm1"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    this.formData.subprices = this.subAreaList;
                    this.data.w = JSON.stringify(this.formData);
                    let ss = new URLSearchParams(this.data);
                    addExpPrice(ss).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        // 刷新表单
                        this.$refs["dataForm1"].resetFields();
                        this.formInput = false;
                        // this.subAreaList=[];
                        this.getList();
                    });
                }
            });
        },
        //修改
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            return true;
        },
        handleForm(index, row) {
            this.loading = true;
            this.query.exppriceid = row.exppriceid;
            getPriceInfo(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.priceInfo = response.data;
                    console.log(this.priceInfo);
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                    this.formVisible = true;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.totalNumber = 0;
                });

            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },

        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    this.data.w = JSON.stringify(this.priceInfo);
                    let ss = new URLSearchParams(this.data);
                    updateExpPrice(ss).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        // 刷新表单
                        this.$refs["dataForm"].resetFields();
                        this.priceInfo = "";
                        this.formVisible = false;
                        this.getList();
                    });
                }
            });
        },
        // 删除
        handleDel(ids) {
            if (ids) {
                this.$confirm("确认要删除吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.loading = true;
                        var params = new URLSearchParams();
                        params.append("ids", ids);
                        deleteExpPrice(params)
                            .then(response => {
                                this.loading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("删除成功");
                                // 刷新数据
                                this.getList();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        delGroup() {
            var ids = this.multipleSelection
                .map(item => item.exppriceid)
                .join(); //获取所有选中行的id组成的字符串，以逗号分隔
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning"
                });
                return;
            }
            this.handleDel(ids);
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        }
    },
    filters: {
        price: function(myInput) {
            if (myInput != null) {
                var val = parseInt(myInput);
                if (typeof val === "number") {
                    return parseFloat(myInput).toFixed(2);
                }
            } else {
                return "-";
            }
        }
    },
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        this.getSubArea();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
</style>
